/**
 * 面接予定日のテキストを改行区切りで配列にして返す
 * @param interviewSchedule
 * @returns {*|array}
 */
export const splitInterviewSchedule = (interviewSchedule) => {
    if (!interviewSchedule) {
        return [];
    }
    return interviewSchedule
        .split('\n')
        .map((string) => string.trim())
        .filter((string) => string);
};
